import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, Signal } from '@angular/core';
import { ButtonModule, SelectModule, InputModule, TextareaModule } from '@sag-ui';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    InvestigationReviewInternationalForm,
    InvestigationReviewInternationalFormGroup
} from '../../../models/cod-review.model';
import { CodReviewOperations } from '../../../operations/cod-review.operations';
import { AttachmentsInputComponent } from '../../../../shared/components/attachments-input/attachments-input.component';
import { CodReviewState } from '../../../state/cod-review.state';
import { select, Store } from '@ngxs/store';
import { SubmitInvestigationReviewInternational } from '../../../state/cod-review.action';
import { distinctUntilChanged, filter, tap } from 'rxjs';
import { config } from './investigation-review-international.config';
import {
    ReviewResult,
    NatureOfComplaintInternational,
    RootCause,
    Through,
    BasicReviewResult
} from '@cod-monorepo/interfaces';
import { CodReviewSuccessComponent } from '../review-success/review-success.component';
import { NgxsFormDirective } from '@ngxs/form-plugin';

@Component({
    selector: 'app-cod-investigation-review-international-step',
    templateUrl: './investigation-review-international.component.html',
    imports: [
        CommonModule,
        SelectModule,
        FormsModule,
        ReactiveFormsModule,
        InputModule,
        ButtonModule,
        AttachmentsInputComponent,
        TextareaModule,
        CodReviewSuccessComponent,
        NgxsFormDirective
    ],
    standalone: true
})
export class CodInvestigationReviewInternationalStepComponent implements OnInit, OnChanges {
    @Input() disabled: boolean;

    protected submitting: Signal<boolean> = select(CodReviewState.submittingInvestigationReviewInt);
    protected submittingSuccess: Signal<boolean> = select(CodReviewState.submittingInvestigationReviewIntSuccess);
    public formGroup: FormGroup<InvestigationReviewInternationalFormGroup>;
    public options: string[] = [];
    public label = '';
    public natureOfComplaint = NatureOfComplaintInternational;
    public throughOptions = Through;
    public basicReviewResult = BasicReviewResult;
    public reviewResult = ReviewResult;
    public rootCause = RootCause;

    constructor(private store: Store) {}

    public ngOnInit(): void {
        this.formGroup = CodReviewOperations.initializeInvestigationReviewInternationalForm();
        this.formGroup.controls.issueType.disable();
        this.initRevisedNatureOfComplaintChange();

        if (this.disabled) {
            this.formGroup.disable();
        }
    }

    public ngOnChanges(): void {
        if (this.disabled) {
            this.formGroup && this.formGroup.disable();
        } else {
            this.formGroup && this.formGroup.enable();
        }
    }

    public submit(): void {
        if (this.formGroup.invalid) {
            return;
        }

        this.store.dispatch(
            new SubmitInvestigationReviewInternational(this.formGroup.value as InvestigationReviewInternationalForm)
        );
        this.formGroup.disable();
    }

    public get invalid(): boolean {
        return this.formGroup.invalid;
    }

    public get noChange(): boolean {
        return this.formGroup.controls.natureOfComplaint.value === 'NO_CHANGE';
    }

    private initRevisedNatureOfComplaintChange(): void {
        this.formGroup.controls.natureOfComplaint.valueChanges
            .pipe(
                filter(value => !!value),
                distinctUntilChanged(),
                tap((value: NatureOfComplaintInternational | 'NO_CHANGE') => {
                    if (!this.disabled) {
                        this.formGroup.controls.issueType.reset();
                        this.formGroup.controls.issueType.enable();
                    }

                    if (value === 'NO_CHANGE') {
                        this.options = Object.values(RootCause);
                        this.label = 'Root Cause';
                        return;
                    }

                    this.options = config[value].options;
                    this.label = config[value].label;
                })
            )
            .subscribe();
    }
}
